import { render } from "./ClassManagement.vue?vue&type=template&id=e4b258f2&scoped=true"
import script from "./ClassManagement.vue?vue&type=script&lang=js"
export * from "./ClassManagement.vue?vue&type=script&lang=js"

import "./ClassManagement.vue?vue&type=style&index=0&id=e4b258f2&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/SIMI-TRAC/SIMI-TRAC-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4b258f2"]])

export default __exports__